export const projectTestIds = {
    colorInputContainer: "color-input-container",
    createFromCopy: "create-from-copy",
    createProject: "create-project",
    saveProjectSettings: "save-project-settings",
    wizardStageBackBtn: "wizard-stage-back-btn",
    wizardStageNextBtn: "wizard-stage-next-btn",

    projectSettings: {
        general: {
            tab: "project-settings-general-tab",
            tabPane: "project-settings-general-tab-pane",
            form: "project-general-settings-form",
            logo: "project-general-settings-logo",
            hugeLogo: "project-general-settings-huge-logo",
            projectNameInput: "project-general-settings-project-name-input",
            selectedLanguage: "project-general-settings-selected-language",
            includeDialogsHistoryCheckbox: "project-general-settings-include-dialogs-history-checkbox",
            downloadButton: "project-general-settings-download-button",
            saveButton: "project-general-settings-save-button"
        },
        dialog: {
            tab: "project-settings-dialog-tab",
            tabPane: "project-settings-dialog-tab-pane",
            form: "project-dialog-settings-form",
            defaultAgent: "project-dialog-settings-default-agent",
            defaultAgentForOutgoingDialog: "project-dialog-settings-default-agent-for-outgoing-dialog",
            dialogInQueueTimeoutMessage: "project-dialog-settings-dialog-in-queue-timeout-message",
            dialogInQueueTimeoutMessageEnabled: "project-dialog-settings-dialog-in-queue-timeout-message-enabled",
            dialogInQueueTimeoutValue: "project-dialog-settings-dialog-in-queue-timeout-value",
            dialogLifeTimeoutValue: "project-dialog-settings-dialog-life-timeout-value",
            finishDialogArticle: "project-dialog-settings-finish-dialog-article",
            finishDialogTimeoutMessage: "project-dialog-settings-finish-dialog-timeout-message",
            finishDialogTimeoutMessageEnabled: "project-dialog-settings-finish-dialog-timeout-message-enabled",
            finishDialogTimeoutValue: "project-dialog-settings-finish-dialog-timeout-value",
            firstTimeoutMessage: "project-dialog-settings-first-timeout-message",
            firstTimeoutMessageEnabled: "project-dialog-settings-first-timeout-message-enabled",
            firstTimeoutValue: "project-dialog-settings-first-timeout-value",
            operatorAgent: "project-dialog-settings-operator-agent",
            secondTimeoutMessage: "project-dialog-settings-second-timeout-message",
            secondTimeoutMessageEnabled: "project-dialog-settings-second-timeout-message-enabled",
            secondTimeoutValue: "project-dialog-settings-second-timeout-value",
            saveButton: "project-dialog-settings-save-button",
            systemEventsAgent: "project-dialog-settings-system-events-agent"
        },
        operator: {
            tab: "project-settings-operator-tab",
            tabPane: "project-settings-operator-tab-pane",
            form: "project-operator-settings-form",
            accordion: "project-operator-settings-accordion",
            accordionToggle: "project-operator-settings-accordion-toggle",
            additionalCountOfPrevAppeal: "project-operator-settings-additional-count-of-prev-appeal",
            allowChatJoinRequests: "project-operator-settings-allow-chat-join-requests",
            allowRestrictAccessToClients: "project-operator-settings-allow-restrict-access-to-clients",
            alwaysOpenChooseTopicWindow: "project-operator-settings-always-open-choose-topic-window",
            auditorDashboardSurveyId: "project-operator-settings-auditor-dashboard-survey-id",
            autoHoldingEnabled: "project-operator-settings-auto-holding-enabled",
            autoLinkToClientWhenRedirect: "project-operator-settings-auto-link-to-client-when-redirect",
            chooseProgramFieldName: "project-operator-settings-choose-program-field-name",
            chooseTopicToFinishDialogAutomatic: "project-operator-settings-choose-topic-to-finish-dialog-automatic",
            chooseTopicToFinishDialogRequired: "project-operator-settings-choose-topic-to-finish-dialog-required",
            chooseTopicToHoldDialogRequired: "project-operator-settings-choose-topic-to-hold-dialog-required",
            clientHoldingMessages: "project-operator-settings-client-holding-messages",
            clientHoldingTimeout: "project-operator-settings-client-holding-timeout",
            clientsSectionName: "project-operator-settings-clients-section-name",
            customSections: "project-operator-settings-custom-sections",
            defaultCountOfPrevAppeal: "project-operator-settings-default-count-of-prev-appeal",
            dialogProgramCatalogId: "project-operator-settings-dialog-program-catalog-id",
            dialogSurveyId: "project-operator-settings-dialog-survey-id",
            dialogTimerEnabled: "project-operator-settings-dialog-timer-enabled",
            dialogTimerTimeoutCustomLabelEnabled: "project-operator-settings-dialog-timer-timeout-custom-label-enabled",
            dialogTimerTimeoutCustomLabelName: "project-operator-settings-dialog-timer-timeout-custom-label-name",
            dialogTimerTimeoutPlusEnabled: "project-operator-settings-dialog-timer-timeout-plus-enabled",
            dialogTopicCatalogId: "project-operator-settings-dialog-topic-catalog-id",
            dialogWaitingForClientAnswerTimeout: "project-operator-settings-dialog-waiting-for-client-answer-timeout",
            dialogWaitingForClientAnswerTimerEnabled:
                "project-operator-settings-dialog-waiting-for-client-answer-timer-enabled",
            dialogWaitingForOperatorAnswerTimeout:
                "project-operator-settings-dialog-waiting-for-operator-answer-timeout",
            dialogWaitingForOperatorAnswerTimerEnabled:
                "project-operator-settings-dialog-waiting-for-operator-answer-timer-enabled",
            dropDialogTimeout: "project-operator-settings-drop-dialog-timeout",
            enableClientsSection: "project-operator-settings-enable-clients-section",
            enableFileSectionCollectFromWholeDialog:
                "project-operator-settings-enable-file-section-collect-from-whole-dialog",
            enableLinkedClientsSection: "project-operator-settings-enable-linked-clients-section",
            enableRegistrationSlots: "project-operator-settings-enable-registration-slots",
            enableSeparateDialogs: "project-operator-settings-enable-separate-dialogs",
            errorMessageWhenInvalidOperatorStatus:
                "project-operator-settings-error-message-when-invalid-operator-status",
            fastReplyHoldTemplates: "project-operator-settings-fast-reply-hold-templates",
            fastReplyTemplates: "project-operator-settings-fast-reply-templates",
            fileSections: "project-operator-settings-file-sections",
            finishDialogWithoutClientResponseTimeout:
                "project-operator-settings-finish-dialog-without-client-response-timeout",
            finishOutgoingDialogAfterStart: "project-operator-settings-finish-outgoing-dialog-after-start",
            forwardingMessage: "project-operator-settings-forwarding-message",
            greenDialogTimerTimeout: "project-operator-settings-green-dialog-timer-timeout",
            hideAIAssistInChat: "project-operator-settings-hide-ai-assist-in-chat",
            hideFiltersInDialogTransfer: "project-operator-settings-hide-filters-in-dialog-transfer",
            hideIdentifiers: "project-operator-settings-hide-identifiers",
            isNotRememberUserLastChannel: "project-operator-settings-is-not-remember-user-last-channel",
            knowledgeBaseHeader: "project-operator-settings-knowledge-base-header",
            linkedClientsSectionName: "project-operator-settings-linked-clients-section-name",
            loadHistoryByEmail: "project-operator-settings-load-history-by-email",
            loadHistoryByPhoneNumber: "project-operator-settings-load-history-by-phone-number",
            mainSurveyId: "project-operator-settings-main-survey-id",
            nameBotByAppealCard: "project-operator-settings-name-bot-by-appeal-card",
            newWorkplaceClientSurveyId: "project-operator-settings-new-workplace-client-survey-id",
            newWorkplaceDialogSurveyId: "project-operator-settings-new-workplace-dialog-survey-id",
            operatorAutoGreetingEnabled: "project-operator-settings-operator-auto-greeting-enabled",
            operatorAutoGreetingMale: "project-operator-settings-operator-auto-greeting-male",
            outgoingMessageIntents: "project-operator-settings-outgoing-message-intents",
            phoneNumberMask: "project-operator-settings-phone-number-mask",
            pushNotificationEnabled: "project-operator-settings-push-notification-enabled",
            pushNotificationTimeout: "project-operator-settings-push-notification-timeout",
            pushNotificationVolumeLevel: "project-operator-settings-push-notification-volume-level",
            respondWithArticleEnabled: "project-operator-settings-respond-with-article-enabled",
            saveButton: "project-operator-settings-save-button",
            sendMessageButtonActionHold: "project-operator-settings-send-message-button-action-hold",
            sendMessageButtonInternalMessage: "project-operator-settings-send-message-button-internal-message",
            sendMessageDefaultAction: "project-operator-settings-send-message-default-action",
            setPreviousTopicsAfterFinishDialog: "project-operator-settings-set-previous-topics-after-finish-dialog",
            showDialogHistory: "project-operator-settings-show-dialog-history",
            showLinkClientFunctional: "project-operator-settings-show-link-client-functional",
            showRerouteQueue: "project-operator-settings-show-reroute-queue",
            shortSurveyId: "project-operator-settings-short-survey-id",
            sortDialogsByClientResponseTime: "project-operator-settings-sort-dialogs-by-client-response-time",
            translateMessageAndHold: "project-operator-settings-translate-message-and-hold",
            translateMessageAndSend: "project-operator-settings-translate-message-and-send",
            triggerMessagesForRunClientHolding: "project-operator-settings-trigger-messages-for-run-client-holding",
            useAIAssistGPT: "project-operator-settings-use-ai-assist-gpt",
            useAIAssistLLM: "project-operator-settings-use-ai-assist-llm",
            useEmoji: "project-operator-settings-use-emoji",
            useSpellChecker: "project-operator-settings-use-spell-checker",
            userDissatisfaction: "project-operator-settings-user-dissatisfaction",
            waitingForClientResponseTimeout: "project-operator-settings-waiting-for-client-response-timeout",
            waitingForClientResponseTimeoutMessages:
                "project-operator-settings-waiting-for-client-response-timeout-messages",
            yellowDialogTimerTimeout: "project-operator-settings-yellow-dialog-timer-timeout"
        },
        statistics: {
            tab: "project-settings-statistics-tab",
            tabPane: "project-settings-statistics-tab-pane",
            form: "project-statistics-settings-form",
            ahtStartDefiningField: "project-statistics-settings-aht-start-defining-field",
            commonReportSlots: "project-statistics-settings-common-report-slots",
            commonReportTimeZone: "project-statistics-settings-common-report-time-zone",
            excludedOperators: "project-statistics-settings-excluded-operators",
            fcr: "project-statistics-settings-fcr",
            fcrSeparateDifferentTopics: "project-statistics-settings-fcr-separate-different-topics",
            funnelSlots: "project-statistics-settings-funnel-slots",
            handledCountField: "project-statistics-settings-handled-count-field",
            saveButton: "project-statistics-settings-save-button",
            slEndDefiningField: "project-statistics-settings-sl-end-defining-field",
            slPeriod: "project-statistics-settings-sl-period",
            timeRangeEndDefiningField: "project-statistics-settings-time-range-end-defining-field",
            timeRangeStartDefiningField: "project-statistics-settings-time-range-start-defining-field",
            unproductiveAnswers: "project-statistics-settings-unproductive-answers"
        },
        system: {
            tab: "project-settings-system-tab",
            tabPane: "project-settings-system-tab-pane",
            form: "project-system-settings-form",
            additionalResendConfigDependsOnQueue: "project-system-settings-additional-resend-config-depends-on-queue",
            assignDialogsByLinkOverLimit: "project-system-settings-assign-dialogs-by-link-over-limit",
            autoPinMessagesEnabled: "project-system-settings-auto-pin-messages-enabled",
            autoPinMessagesTypes: "project-system-settings-auto-pin-messages-types",
            channelOnDialogPanel: "project-system-settings-channel-on-dialog-panel",
            colorSchemaBaseColor: "project-system-settings-color-schema-base-color",
            colorSchemaChangeAllow: "project-system-settings-color-schema-change-allow",
            colorSchemaEditorColor: "project-system-settings-color-schema-editor-color",
            colorSchemaLinkColor: "project-system-settings-color-schema-link-color",
            colorSchemaUsing: "project-system-settings-color-schema-using",
            convertTemplate: "project-system-settings-convert-template",
            customMenus: "project-system-settings-custom-menus",
            customPermissions: "project-system-settings-custom-permissions",
            customPermissionsAllow: "project-system-settings-custom-permissions-allow",
            defaultQueueIfNotRouted: "project-system-settings-default-queue-if-not-routed",
            dialogSwitchNotificationWebhook: "project-system-settings-dialog-switch-notification-webhook",
            disableMarkupModal: "project-system-settings-disable-markup-modal",
            displayOperatorIdEnabled: "project-system-settings-display-operator-id-enabled",
            displayOperatorRoleEnabled: "project-system-settings-display-operator-role-enabled",
            enableMessageSendBehaviour: "project-system-settings-enable-message-send-behaviour",
            errorMessageAssignDialogsByLinkOverLimit:
                "project-system-settings-error-message-assign-dialogs-by-link-over-limit",
            freeSwitchingBetweenStatuses: "project-system-settings-free-switching-between-statuses",
            hideChoiceQueueIfNotRouted: "project-system-settings-hide-choice-queue-if-not-routed",
            highlightAppealCardsWithSpecialSlots: "project-system-settings-highlight-appeal-cards-with-special-slots",
            informationMaskingPatterns: "project-system-settings-information-masking-patterns",
            logoHugeSizeChangeAllow: "project-system-settings-logo-huge-size-change-allow",
            observedSlots: "project-system-settings-observed-slots",
            operatorQuestionaryForNewUsersEnabled: "project-system-settings-operator-questionary-for-new-users-enabled",
            operatorQuestionaryId: "project-system-settings-operator-questionary-id",
            profileContactInfoQuestionaryId: "project-system-settings-profile-contact-info-questionary-id",
            profilePersonalInfoQuestionaryId: "project-system-settings-profile-personal-info-questionary-id",
            profileSystemInfoQuestionaryId: "project-system-settings-profile-system-info-questionary-id",
            saveButton: "project-system-settings-save-button",
            switchToBotWindowMessage: "project-system-settings-switch-to-bot-window-message",
            switchToBotWindowTitle: "project-system-settings-switch-to-bot-window-title",
            updateClientDataFromChannel: "project-system-settings-update-client-data-from-channel"
        }
    }
} as const
